import { render } from "./VCode.vue?vue&type=template&id=34aade1d&ts=true"
import script from "./VCode.vue?vue&type=script&lang=ts"
export * from "./VCode.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__